<template>
  <a :class="['com-app-button font-bold', { 'com-btn-disabled': disabled }]" @click="handleClick">
    <slot>{{ t('appGenerator.generate') }}</slot>
    <div v-if="errorTip" class="error-tip">
      <span>{{ errorTip }}</span>
    </div>
  </a>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  defineOptions({ name: 'AppButton' })
  const emit = defineEmits(['clickEvent'])
  const { t } = useI18n()
  let lastClickTime = 0
  const props = defineProps({
    disabled: {
      type: Boolean,
      default: false
    },
    minInterval: {
      type: Number,
      default: 0
    },
    errorTip: {
      type: String,
      default: ''
    }
  })

  const handleClick = () => {
    if (props.disabled) return
    const now = Date.now()
    if (props.minInterval > 0 && now - lastClickTime < props.minInterval) return
    lastClickTime = now
    emit('clickEvent')
  }
</script>

<style scoped lang="stylus">
  @import './index.styl'
</style>
